import { MenuOutlined, PlusOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import Logo from '../../../../../assets/logos/texterLogos/texterBigLogo.svg';
import { useStore } from '../../../../../store/rootStore';
import Section from '../../../../../store/NavigationStore/Section';
import { NotificationsDropdown } from '../../../../Notifications';
import styles from './MobileTopBar.module.scss';
const MobileTopBar = ({ className }) => {
    const { navigation, partnerTheme } = useStore();
    const { sectionOpen } = navigation;
    return (React.createElement("div", { className: classnames(styles.container, className) },
        React.createElement("img", { className: styles.image, src: partnerTheme ? partnerTheme.iconSmall : Logo, alt: "Logo" }),
        React.createElement("div", { className: styles.actions }, sectionOpen.mobileDrawer ? (React.createElement(PlusOutlined, { onClick: () => navigation.toggleSection(Section.mobileDrawer), className: classnames(styles.topBarIcon, styles.topBarIconCross) })) : (React.createElement(React.Fragment, null,
            React.createElement(NotificationsDropdown, null),
            React.createElement(MenuOutlined, { onClick: () => navigation.toggleSection(Section.mobileDrawer), className: styles.topBarIcon }))))));
};
export default observer(MobileTopBar);
